import Component from '../core/Component'
import { toggleClass, queryAll } from '../utils/dom'
import support from '../utils/BrowserSupport'

const STATES = {
    ACTIVE: 'is-active',
    VISIBLE: 'is-visible',
    LEAVING: 'is-leaving'
}

export default class ProfileCard extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            quote: null
        }

        this.isDefault = this.element.classList.contains(STATES.ACTIVE)
        this.isReady = false
    }

    prepare() {
        this.element.addEventListener(support.transitionEnd, event => {
            if (event.target !== this.element) {
                return
            }

            if (!this.is(STATES.ACTIVE)) {
                this.element.classList.remove(STATES.VISIBLE)
                this.element.classList.remove(STATES.LEAVING)
            }

            if (this.promise) {
                this.promise.resolve()
                this.promise = null
            }
        })
    }

    destroy() {
        if (this.promise) {
            this.promise.reject()
            this.promise = null
        }
    }

    handleResize = () => {
        this.resize()
    }

    enter() {
        this.element.classList.add(STATES.VISIBLE)
        this.element.offsetWidth
        this.element.classList.add(STATES.ACTIVE)
    }

    leave() {
        this.element.classList.add(STATES.LEAVING)
        this.element.offsetWidth
        this.element.classList.remove(STATES.ACTIVE)

        let res = null
        let rej = null

        const promise = new Promise((resolve, reject) => {
            res = resolve
            rej = reject
        })

        promise.resolve = res
        promise.reject = rej

        this.promise = promise

        return this.promise
    }

    reset() {
        toggleClass(this.element, STATES.ACTIVE, this.isDefault)
    }
}
